export const downloadXLSX = async ({ rootGetters }, {
    payload
}) => {
    payload.organizationId = rootGetters['app/getSelectedOrganization'].id

    const jsonPayload = encodeURIComponent( JSON.stringify(payload) )

    window.open('/downloads/xlsx-adv-balance-history?_=' + `${jsonPayload}`)
}
